import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Header from '../../../components/controls/header/Header.jsx';
import Image from '../../../components/controls/image/Image.jsx';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import {
    ICON_SETTING,
    IMAGE_LOGO
} from 'pluton-core/lib/constants/image.constant';


class MoreContainer extends Component {

    renderHeader = () => {

        return (
            <Header headerTitle='More'>
                <div className="header__logo header__logo--left">
                    <Image
                        src={IMAGE_LOGO}
                        className="header__icon"
                        imgClassName="icon icon--header"
                    />
                </div>
                <Link className="header__link header__link--right"
                      to={`${routes.settings()}`}>
                    <Image
                        src={ ICON_SETTING }
                        className="header__icon header__icon--right"
                        imgClassName="icon icon--header"
                    />
                </Link>
            </Header>
        );
    };


    render() {
        return (
            <div className="app-container">
                <div className="page">
                    {this.renderHeader()}
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {};
};
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MoreContainer);



// WEBPACK FOOTER //
// ./app/containers/pages/core/More.container.jsx